/**
 * RouteSkeleton — universal shimmer fallback for lazy-loaded routes & settings panels.
 *
 * Shows during the chunk fetch.  Uses pure CSS animation (no Framer Motion)
 * to keep the fallback paint cheap.  Adapts to dark / light via cs-* tokens.
 */
const RouteSkeleton = ({ variant = 'page' }) => {
  if (variant === 'panel') {
    return (
      <div className="space-y-4 animate-pulse" data-testid="route-skeleton-panel">
        <div className="h-10 w-1/3 rounded-lg" style={{ background: 'var(--cs-bg-hover)' }} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {[0, 1, 2, 3].map(i => (
            <div key={i} className="h-24 rounded-xl" style={{ background: 'var(--cs-bg-surface)' }} />
          ))}
        </div>
        <div className="h-64 rounded-xl" style={{ background: 'var(--cs-bg-surface)' }} />
      </div>
    );
  }

  // Full-page skeleton — title + hero block + grid
  return (
    <div className="space-y-6 animate-pulse" data-testid="route-skeleton">
      <div className="h-8 w-48 rounded-lg" style={{ background: 'var(--cs-bg-hover)' }} />
      <div className="h-3 w-72 rounded" style={{ background: 'var(--cs-bg-surface)' }} />
      <div className="h-40 rounded-2xl" style={{ background: 'var(--cs-bg-surface)' }} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[0, 1, 2, 3, 4, 5].map(i => (
          <div key={i} className="h-32 rounded-xl" style={{ background: 'var(--cs-bg-surface)' }} />
        ))}
      </div>
    </div>
  );
};

export default RouteSkeleton;
